import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotepad = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 1,
			width: 11,
			height: 14,
			rx: 1,
			stroke: "#212121",
			strokeWidth: 1.2,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 3.5,
			y1: 5,
			x2: 7,
			y2: 5,
			stroke: "#212121",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 3.5,
			y1: 8,
			x2: 7,
			y2: 8,
			stroke: "#212121",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 3.5,
			y1: 11,
			x2: 5.5,
			y2: 11,
			stroke: "#212121",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 7L14.5 1.5",
			stroke: "#FFC408",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 7L14.5 1.5",
			stroke: "#212121",
			strokeWidth: 1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 7.5L8 10L10.5 9.5L8.5 7.5Z",
			fill: "#212121"
		})
	]
});
export default SvgNotepad;
